import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';
import Loader from 'Components/Loader';

const DownloadButton = styled(Button)`
  background: #fff !important;
  margin-right: 16px !important;
`;

const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 500px;
  background-color: rgb(234, 234, 234);
  padding: 20px;
`;
const MessageWrapper = styled.div`
  width: 100%;
`;
const TextFieldCustom = styled(TextField)`
  width: 100%;
`;
const SelectCustom = styled(Select)`
  min-width: 90px !important;
`;
const SelectWrapper = styled.div`
  margin-bottom: 20px;
`;

const styles = theme => ({
  root: {
    margin: 0,
    padding: '20px',
    backgroundColor: 'rgb(255, 202, 40)',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    right: '10px',
    top: '10px',
    color: 'grey',
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: '20px',
    backgroundColor: 'rgb(234, 234, 234)',
  },
}))(MuiDialogActions);

const CustomizedDialogs = props => {
  return (
    <Dialog
      onClose={props.closeMessageDialog}
      aria-labelledby="customized-dialog-title"
      open={props.open}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={props.closeMessageDialog}
      >
        ARUP Luminaire Broker
      </DialogTitle>
      <DialogContent>
        <SelectWrapper>
          <FormControl>
            <InputLabel>Email to:</InputLabel>
            <SelectCustom value={props.mailTo} onChange={props.sendMailTo}>
              <MenuItem value={'ALL'}>ALL USERS</MenuItem>
              <MenuItem value={'ALL_ARUP'}>ALL DEMAND USERS</MenuItem>
              <MenuItem value={'ALL_COMPANY'}>ALL COMPANY USERS</MenuItem>
            </SelectCustom>
          </FormControl>
        </SelectWrapper>
        <MessageWrapper>
          <TextFieldCustom
            label="Message"
            variant="outlined"
            multiline
            rows={6}
            rowsMax={8}
            onChange={props.setMessage}
            value={props.message}
          />
        </MessageWrapper>
      </DialogContent>
      <DialogActions>
        <DownloadButton
          disabled={props.message === ''}
          autoFocus
          onClick={props.sendEmail}
          variant="contained"
          className="t-weight-b criteria-button"
        >
          <React.Fragment>
            <Loader isLoading={props.sending} size={32} />
            <p
              style={{
                visibility: props.sending ? 'hidden' : 'visible',
              }}
            >
              Send message
            </p>
          </React.Fragment>
        </DownloadButton>
      </DialogActions>
    </Dialog>
  );
};

export default CustomizedDialogs;
